var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.$.range] },
    [
      _c("vgp-label-slot", {
        style: { marginBottom: "8px" },
        attrs: { label: _vm.locales("filter_number_type_custom_column_from") },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "div",
                  { style: { display: "flex" } },
                  [
                    _c("vgp-date-picker", {
                      style: { width: "50%", marginRight: "8px" },
                      attrs: {
                        value: _vm.rangeValue.start,
                        "has-footer-slot": false,
                      },
                      on: { onChange: _vm.handleChangeStartDate },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var inputValue = ref.inputValue
                            var togglePopover = ref.togglePopover
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return (function () {
                                        return togglePopover()
                                      })($event)
                                    },
                                  },
                                },
                                [
                                  _c("vgp-input", {
                                    ref: "input",
                                    attrs: {
                                      placeholder: _vm.locales(
                                        "filter_number_type_custom_column_from"
                                      ),
                                      value: inputValue,
                                      small: true,
                                      "icons-left": [
                                        {
                                          name: "calendar",
                                          type: "regular",
                                          size: 24,
                                          handler: null,
                                        },
                                      ],
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("vgp-input", {
                      ref: "input",
                      style: { width: "50%" },
                      attrs: {
                        placeholder: _vm.locales(
                          "filter_number_type_custom_column_from"
                        ),
                        value: _vm.timeValue.from,
                        small: true,
                        "icons-left": [{ name: "time", handler: null }],
                      },
                      on: {
                        onChange: function ($event) {
                          return _vm.onChangeTimeInput(
                            "from",
                            $event.target.value
                          )
                        },
                      },
                      model: {
                        value: _vm.timeValue.from,
                        callback: function ($$v) {
                          _vm.$set(_vm.timeValue, "from", $$v)
                        },
                        expression: "timeValue.from",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("vgp-label-slot", {
        attrs: { label: _vm.locales("filter_number_type_custom_column_to") },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "div",
                  { style: { display: "flex" } },
                  [
                    _c("vgp-date-picker", {
                      style: { width: "50%", marginRight: "8px" },
                      attrs: {
                        value: _vm.rangeValue.end,
                        "has-footer-slot": false,
                      },
                      on: { onChange: _vm.handleChangeEndDate },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var inputValue = ref.inputValue
                            var togglePopover = ref.togglePopover
                            return [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return (function () {
                                        return togglePopover()
                                      })($event)
                                    },
                                  },
                                },
                                [
                                  _c("vgp-input", {
                                    ref: "input",
                                    attrs: {
                                      placeholder: _vm.locales(
                                        "filter_number_type_custom_column_to"
                                      ),
                                      value: inputValue,
                                      small: true,
                                      "icons-left": [
                                        {
                                          name: "calendar",
                                          type: "regular",
                                          size: 24,
                                          handler: null,
                                        },
                                      ],
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("vgp-input", {
                      ref: "input",
                      style: { width: "50%" },
                      attrs: {
                        placeholder: _vm.locales(
                          "filter_number_type_custom_column_to"
                        ),
                        readonly: _vm.readonly,
                        value: _vm.timeValue.to,
                        small: true,
                        "icons-left": [{ name: "time", handler: null }],
                      },
                      on: {
                        onChange: function ($event) {
                          return _vm.onChangeTimeInput(
                            "to",
                            $event.target.value
                          )
                        },
                      },
                      model: {
                        value: _vm.timeValue.to,
                        callback: function ($$v) {
                          _vm.$set(_vm.timeValue, "to", $$v)
                        },
                        expression: "timeValue.to",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }